import { StyleSheet, Image, ImageBackground } from "react-native";
import React from "react";
import { Modal, VStack } from "native-base";
import { colors } from "../../../styles/GlobalStyle";
import { H2, Txt } from "../../TextsComponents";
import DimensionsHook from "../../../hooks/DimensionsHook";

import { useTranslation } from "react-i18next";
import { PrimaryButton } from "../../Buttons";

const BuyTrailModal = ({ isOpen, setIsOpen, navigation }) => {
  const { t } = useTranslation();
  const { width, isMobile } = DimensionsHook();
  const isDesktop = width > 1000;
  const closeHandler = () => {
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={closeHandler}>
      <Modal.Content style={styles.container}>
        <Modal.Body>
          <ImageBackground
            source={require("../../../assets/background.png")}
            style={{ flex: 1 }}
          >
            <Modal.CloseButton
              focusable={false}
              style={{ marginRight: isMobile ? 0 : 10 }}
            />
            <VStack
              justifyContent="center"
              alignItems="center"
              style={{ marginTop: 40 }}
            >
              <H2
                style={{
                  textAlign: "center",
                  lineHeight: isMobile ? 32 : 40,
                }}
              >
                {t("buy_trail_modal.title")}
              </H2>

              <Txt
                style={{
                  marginTop: 30,
                  textAlign: "center",
                  marginHorizontal: 10,
                }}
              >
                {t("buy_trail_modal.text1")}
              </Txt>
              <Txt
                style={{
                  marginTop: 15,
                  textAlign: "center",
                  marginHorizontal: 10,
                }}
              >
                {t("buy_trail_modal.text2")}
              </Txt>
              <Txt
                style={{
                  marginTop: 15,
                  textAlign: "center",
                  marginHorizontal: 10,
                }}
              >
                {t("buy_trail_modal.text3")}
              </Txt>

              <PrimaryButton
                onPress={() => {
                  setIsOpen(false);

                  navigation.navigate("AccountBuy", { showByTrail: true });
                }}
                style={{ marginVertical: 30 }}
              >
                {t("buy_trail_modal.button")}
              </PrimaryButton>
            </VStack>
            {isDesktop && (
              <Image
                source={{
                  uri: "https://firebasestorage.googleapis.com/v0/b/khalil-chikhaoui.appspot.com/o/mascotte.png?alt=media&token=b9dbf40d-3a50-496a-ad1a-47b2c9929728",
                }}
                style={{
                  width: 89,
                  height: 145,
                  position: "absolute",
                  bottom: 0,
                  right: 40,
                }}
              />
            )}
          </ImageBackground>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

export default BuyTrailModal;

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.white,
    width: "95%",
    maxWidth: 1000,
    maxHeight: 5000,
  },
});
